import React, { Fragment } from 'react'
import { Box, TextField, Typography, Chip, useTheme, useMediaQuery } from '@mui/material'
import { CollapsibleInputCard } from '../../../components/_WMS/CollapsibleInputCard'
import { LoadingButton } from '../../../components/_EOS/Button/LoadingButton/LoadingButton'

interface DestinyPositionSectionProps {
  destinyInputRef: React.RefObject<HTMLInputElement>
  localDestinyPosition: string
  setLocalDestinyPosition: (value: string) => void
  destinyValidated: boolean
  destinyValidationFailed: boolean
  isValidating: boolean
  isAutoAssignedPosition: boolean
  handleValidateDestiny: () => void
  handleEditDestiny: () => void
  sharedState: {
    posicionDestino: string
    isDamaged: boolean
  }
}

export const DestinyPositionSection: React.FC<DestinyPositionSectionProps> = ({
  destinyInputRef,
  localDestinyPosition,
  setLocalDestinyPosition,
  destinyValidated,
  destinyValidationFailed,
  isValidating,
  isAutoAssignedPosition,
  handleValidateDestiny,
  handleEditDestiny,
  sharedState
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box mb={3}>
      <CollapsibleInputCard
        title="Posición de Destino"
        isValidated={destinyValidated}
        validationFailed={destinyValidationFailed}
        onEdit={handleEditDestiny}
        isMobile={isMobile}
        expandedContent={
          <Fragment>
            {sharedState.isDamaged && isAutoAssignedPosition && (
              <Typography variant="body2" style={{ color: theme.palette.success.main, marginBottom: 16 }}>
                Esta posición fue asignada automáticamente para el producto que requiere ir a calidad. Puede editarla si es necesario.
              </Typography>
            )}
            {sharedState.isDamaged && !isAutoAssignedPosition && (
              <Typography variant="body2" style={{ color: theme.palette.primary.main, marginBottom: 16 }}>
                Se ha pre-llenado con CALIDAD-TRANSFERENCIA para producto que requiere ir a calidad. Puede editar si es necesario.
              </Typography>
            )}
            <Box display="flex" flexDirection={isMobile ? 'column' : 'row'}>
              <TextField
                inputRef={destinyInputRef}
                label="Código de Posición"
                variant="outlined"
                fullWidth
                value={localDestinyPosition}
                onChange={(e) => setLocalDestinyPosition(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleValidateDestiny()
                  }
                }}
                error={destinyValidationFailed}
                style={{
                  marginRight: isMobile ? 0 : theme.spacing(1),
                  marginBottom: isMobile ? theme.spacing(2) : 0
                }}
              />
              <LoadingButton
                loading={isValidating}
                variant="contained"
                color="primary"
                onClick={handleValidateDestiny}
                disabled={!localDestinyPosition.trim()}
                fullWidth={isMobile}
                style={{ minWidth: isMobile ? 'auto' : '100px' }}
              >
                Validar
              </LoadingButton>
            </Box>
          </Fragment>
        }
        collapsedSummary={`Posición Destino: ${sharedState.posicionDestino}`}
        collapsedChips={
          sharedState.isDamaged && (
            <Chip
              label="Requiere Calidad"
              color="secondary"
              size="small"
            />
          )
        }
      />
    </Box>
  )
}